import { createStore } from '@/common/pinia';
import type { ApiResponse } from '@/common/services/api.service-new';
import type { EsaBiomassLayerResponse, EsaBiomassStatsResponse } from './esa-biomass.types';

/**
 * Cache for the ESA CCI Above-Ground Biomass product served via the analytics
 * infrastructure (`<ForestStructureTool>`). The layer response carries all 10 epochs'
 * tile URLs in one payload, so it's a single slot (fetched once). Stats are cached per
 * `${year}:${JSON.stringify(coords)}` because the same AOI returns different numbers per
 * epoch. Sibling of `SoilStore`.
 */
class EsaBiomassStore {
  private layer: ApiResponse<EsaBiomassLayerResponse> | null = null;

  /** Per-(year, polygon) stats keyed by `${year}:${JSON.stringify(coords)}`. */
  private statsCache: Map<string, EsaBiomassStatsResponse> = new Map();

  public getLayer(): ApiResponse<EsaBiomassLayerResponse> | null {
    return this.layer;
  }

  public setLayer(layer: ApiResponse<EsaBiomassLayerResponse>): void {
    this.layer = layer;
  }

  public getStatsCache(fingerprint: string): EsaBiomassStatsResponse | undefined {
    return this.statsCache.get(fingerprint);
  }

  public setStatsCache(fingerprint: string, stats: EsaBiomassStatsResponse): void {
    this.statsCache.set(fingerprint, stats);
  }
}

const useEsaBiomassStore = createStore(EsaBiomassStore);

export { useEsaBiomassStore, type EsaBiomassStore };
